import { z } from "zod";

export const contactStatusFilterSchema = z.enum(["all", "active", "unsubscribed", "suppressed"]);

export const contactSortFieldSchema = z.enum([
  "name",
  "shopDomain",
  "status",
  "amountSpent",
  "createdAt"
]);

/**
 * 絞り込み・並び替え・ページングをすべて URL に持たせる。
 * リンクを共有すれば相手にも同じ画面が再現される（原則 7）。
 */
export const contactsSearchSchema = z.object({
  q: z.string().trim().max(100).catch("").default(""),
  status: contactStatusFilterSchema.catch("all").default("all"),
  sort: contactSortFieldSchema.catch("createdAt").default("createdAt"),
  dir: z.enum(["asc", "desc"]).catch("desc").default("desc"),
  page: z.coerce.number().int().min(1).catch(1).default(1),
  pageSize: z.coerce.number().int().min(25).max(100).catch(25).default(25)
});

export type ContactStatusFilter = z.infer<typeof contactStatusFilterSchema>;
export type ContactSortField = z.infer<typeof contactSortFieldSchema>;
export type ContactsSearch = z.infer<typeof contactsSearchSchema>;
